import { ArrowNext, Calendar } from "@untitledui/icons";
import type { PeriodStatsView } from "@mfa-aff/shared";
import { IconChip, Money, formatNumber } from "@mfa-aff/ui";
import { Button } from "@mfa-aff/ui/components/base/buttons/button";

const Row = ({ label, value }: { label: string; value: React.ReactNode }) => (
    <div className="flex items-center justify-between gap-3 py-2.5">
        <dt className="text-sm text-tertiary">{label}</dt>
        <dd className="text-sm font-semibold text-primary digits-tabular">{value}</dd>
    </div>
);

/** «این ماه»: this Tehran month's clicks, orders, sales and commission. */
export const MonthCard = ({ month }: { month: PeriodStatsView }) => (
    <section className="flex h-full flex-col gap-4 rounded-2xl bg-primary p-5 shadow-xs ring-1 ring-secondary ring-inset md:p-6" aria-labelledby="month-title">
        <div className="flex items-center gap-3">
            <IconChip icon={Calendar} color="brand" />
            <div className="flex flex-col">
                <p className="text-xs text-tertiary">کارنامهٔ این ماه</p>
                <h2 id="month-title" className="text-lg font-semibold text-primary">
                    {month.label}
                </h2>
            </div>
        </div>
        <dl className="flex flex-col divide-y divide-secondary">
            <Row label="کلیک روی لینک‌ها" value={formatNumber(month.clicks)} />
            <Row label="سفارش" value={formatNumber(month.orders)} />
            <Row label="فروش تازه" value={formatNumber(month.newSales)} />
            <Row label="تمدید" value={formatNumber(month.renewals)} />
            <Row label="پورسانت این ماه" value={<Money rial={month.commissionTotalRial} size="sm" />} />
        </dl>
        <Button href="/links/stats" color="link-color" size="sm" iconTrailing={ArrowNext} className="mt-auto self-start">
            آمار کامل لینک‌ها
        </Button>
    </section>
);
